module.exports = __webpack_public_path__ + "static/revojs19-1-2bd4c5b428ee4749f44e020f7939cb31.jpg";